export const COLORS = {
  BLACK: '#000',
  BUTTON_BACKGROUND: 'rgba(49, 55, 67, 0.07)',
  CONTENT_BACKGROUND: '#fbfcff',
  DROPBOX: '#007ee5',
  ERROR_LIGHT: 'rgba(255, 45, 79, 0.15)',
  ERROR: '#ff2d4f',
  GOOGLE: '#4285f4',
  IMAGE_OVERLAY: 'rgba(0, 0, 0, 0.6)',
  INPUT_BORDER: '#ced4da',
  OFFICE: '#ea3e23',
  PLACEHOLDER_TEXT: 'rgba(0, 0, 0, 0.87)',
  PRIMARY_BORDER_COLOR_LIGHT: 'rgba(49, 55, 67, 0.15)',
  PRIMARY_BORDER_COLOR: 'rgba(49, 55, 67, 0.1)',
  PRIMARY_DARK: '#0069d8',
  PRIMARY_LIGHT: 'rgb(0, 122, 250,0.15)',
  PRIMARY_TEXT: '#313743',
  PRIMARY: '#007afa',
  SECONDARY_BORDER_COLOR: 'rgba(0, 0, 0, 0.1)',
  SECONDARY_LIGHT: 'rgba(49, 55, 67, 0.66)',
  SECONDARY_ULTRA_LIGHT: 'rgba(49, 55, 67, 0.33)',
  SECONDARY: '#313743',
  SELECT_HOVER: '#DEEBFF',
  SKELETON_BACKGROUND: '#E1E1E1',
  SUCCESS_LIGHT: 'rgba(33, 189, 68, 0.15)',
  SUCCESS: '#21bd44',
  TABLE_HEADER_BACKGROUND: 'rgb(250, 250, 250)',
  TABLE_ROW_HOVER_BACKGROUND: 'rgba(0, 0, 0, 0.07)',
  WARNING: '#FFC400',
  WHITE: '#fff',
  GREEN: '#4CAF50',
  DARK_BLUE: '#0E57C4',
}

export const GRAPH_COLORS = {
  LABEL_TEXT: COLORS.SECONDARY,
  LEGEND_TEXT: COLORS.SECONDARY,
  INVOICE_STROKE: COLORS.SUCCESS,
  RECEIPT_STROKE: COLORS.PRIMARY,
  HOTEL_FOLIO_STROKE: COLORS.ERROR,
  INVOICE_AREA: COLORS.SUCCESS_LIGHT,
  GRID_STROKE: 'rgba(0, 0, 0, 0.08)',
  RECEIPT_AREA: COLORS.PRIMARY_LIGHT,
  HOTEL_FOLIO_AREA: COLORS.ERROR_LIGHT,
}

export const TAG_COLORS = {
  PAID: COLORS.SUCCESS,
  UNPAID: COLORS.ERROR,
  PENDING: COLORS.PRIMARY,
  UNPAID_BACKGROUND: COLORS.ERROR_LIGHT,
  PAID_BACKGROUND: COLORS.SUCCESS_LIGHT,
  PENDING_BACKGROUND: COLORS.PRIMARY_LIGHT,
}

export const styleProperties = {
  INPUT_TEXT_BOX_SHADOW: `0 0 0 1px ${COLORS.PRIMARY}`,
  INPUT_TEXT_ERROR_BOX_SHADOW: `0 0 0 1px ${COLORS.ERROR}`,
  INPUT_TEXT_SUCCESS_BOX_SHADOW: `0 0 0 1px ${COLORS.SUCCESS}`,
}

export const HEADER_HEIGHT = 56
export const SIDEBAR_WIDTH_COLLAPSED = 70
export const CONTAINER_MAX_WIDTH = 1500
export const SMALL_LOADER_HEIGHT = 6
export const LARGE_LOADER_HEIGHT = 8

export default {
  typography: {
    useNextVariants: true,
  },
  fontFamily: 'Lato, Arial, sans-serif',
  palette: {
    primary: {
      main: COLORS.PRIMARY,
      text: COLORS.PRIMARY_TEXT,
      light: COLORS.PRIMARY_LIGHT,
    },
    secondary: {
      main: COLORS.SECONDARY,
      light: COLORS.SECONDARY_LIGHT,
    },
    error: {
      main: COLORS.ERROR,
      light: COLORS.ERROR_LIGHT,
    },
    success: {
      main: COLORS.SUCCESS,
      light: COLORS.SUCCESS_LIGHT,
    },
  },
  spacing: 4,
  overrides: {
    MuiInput: {
      underline: {
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `1px solid ${COLORS.PRIMARY}`,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          borderRadius: 2,
          borderColor: COLORS.INPUT_BORDER,
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: COLORS.INPUT_BORDER,
        },
      },
    },
  },
}
